export const UPDATE_RULE_SET = 'UPDATE_RULE_SET';
export const UPDATE_VALIDATION_RULE = 'UPDATE_VALIDATION_RULE';
export const UPDATE_BREAK_RULE_SET = 'UPDATE_BREAK_RULE_SET';
export const ADD_ROLLING_PERIOD_RULE = 'ADD_ROLLING_PERIOD_RULE';
export const REMOVE_ROLLING_PERIOD_RULE_AT_INDEX = 'REMOVE_ROLLING_PERIOD_RULE_AT_INDEX';
export const UPDATE_CURRENT_RULE_SET_IN_LIST = 'UPDATE_CURRENT_RULE_SET_IN_LIST';
export const UPDATE_CURRENT_AWARDING_RULE = 'UPDATE_CURRENT_AWARDING_RULE';
export const UPDATE_CURRENT_CUSTOM_DATA_FIELD_INFOS = 'UPDATE_CURRENT_CUSTOM_DATA_FIELD_INFOS';
export const UPDATE_CURRENT_HYPERFIND_BELONGING_INFO = 'UPDATE_CURRENT_HYPERFIND_BELONGING_INFO';
export const UPDATE_CURRENT_DATAVIEW_INFOS = 'UPDATE_CURRENT_DATAVIEW_INFOS';
export const RESET_CURRENT_AWARDING_RULE = 'RESET_CURRENT_AWARDING_RULE';
export const RESET_RULE_SET = 'RESET_RULE_SET';
export const RESET_AWARDING_RULE_STORE = 'RESET_AWARDING_RULE_STORE';
export const RESET_VALIDATION_RULE_STORE = 'RESET_VALIDATION_RULE_STORE';
export const RESET_BREAK_RULE_STORE = 'RESET_BREAK_RULE_STORE';
export const ACTION_LOADING = 'ACTION_LOADING';
